/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */
import * as Sentry from '@sentry/react';
import { StrictMode, startTransition, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
import { HydratedRouter } from 'react-router/dom';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://9d4ea57631c6ebb74ac41389f5daa499@o4506732717867008.ingest.us.sentry.io/4507809068220416',
    // サーバ側 (instrumentation.server.mjs) と同じ値。未設定だと Sentry は production を
    // 既定にしてしまい、dev / Vercel プレビューのイベントが prd に混ざる。
    // Vite はビルド時に VITE_ 接頭辞の付いた変数だけをバンドルへ埋め込む。
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'unknown',
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,

    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
